export default {
  prodRelativeUrl: '',
  jsonUrl: '/store/glasses.json',
  glassesBaseUrl: 'https://www.eschenbach-eyewear.com/wp-content/uploads/glasses/',
  useSessionStore: false,
  buttonstyles: 'btn btn-default',
  layouts: {'colorselect': 'list'},
  decorations: {
    opticianBtn: 'fa fa-map-marker-alt',
    infoDownloadBtn: 'fa-regular fa-file-pdf',
    favoriteBtn: 'fa-regular fa-star',
    infoBtn: 'fa-solid fa-circle-question'
  },
  brand: "eyewear",
  initialview: ""
}
